export const translations = {
  en: {
    translation: {
      nav: {
        home: "Home",
        about: "About",
        skills: "Skills",
        experience: "Experience",
        projects: "Projects",
        education: "Education",
        volunteering: "Volunteering",
        honors: "Honors",
        contact: "Contact"
      },
      hero: {
        greeting: "Hi, I'm",
        name: "Oussama CHAABENE",
        title: "AI Engineer & Data Engineer",
        subtitle: "Recent Data Engineering graduate specializing in AI and distributed systems",
        downloadResume: "Download Resume",
        contactMe: "Contact Me"
      },
      about: {
        title: "About Me",
        content: "I'm an AI engineer with hands-on experience building and deploying intelligent systems  from Agentic AI solutions like real-time voice agents and automated chatbots, to scalable RAG architectures, distributed LLM deployments and machine-learning pipelines that solve real-world technical challenges."
      },
      skills: {
        title: "Skills",
        categories: {
          languages: "Languages & Frameworks",
          aiml: "AI/ML Technologies",
          infrastructure: "Infrastructure & DevOps",
          databases: "Databases & Data Processing",
          tools: "Development Tools"
        }
      },
      experience: {
        title: "Work Experience",
        current: "Current",
        duration: "Duration"
      },
      projects: {
        title: "Projects",
        viewGithub: "View on GitHub",
        techStack: "Tech Stack"
      },
      education: {
        title: "Education",
        degree: "Degree",
        field: "Field of Study"
      },
      volunteering: {
        title: "Volunteering & Leadership"
      },
      honors: {
        title: "Honors & Awards"
      },
      contact: {
        title: "Get In Touch",
        subtitle: "Feel free to reach out for collaborations or just a friendly hello",
        email: "Email",
        phone: "Phone",
        linkedin: "LinkedIn",
        location: "Location",
        form: {
          name: "Your Name",
          email: "Your Email",
          message: "Your Message",
          submit: "Send Message",
          sending: "Sending..."
        },
        successMessage: "Thank you! Your message has been sent successfully.",
        errorMessage: "Sorry, there was an error sending your message. Please try again."
      },
      footer: {
        rights: "All rights reserved"
      }
    }
  },
  fr: {
    translation: {
      nav: {
        home: "Accueil",
        about: "À propos",
        skills: "Compétences",
        experience: "Expérience",
        projects: "Projets",
        education: "Formation",
        volunteering: "Bénévolat",
        honors: "Honneurs",
        contact: "Contact"
      },
      hero: {
        greeting: "Bonjour, je suis",
        name: "Oussama CHAABENE",
        title: "Ingénieur IA & Ingénieur Data",
        subtitle: "Diplômé récent en ingénierie des données spécialisé en IA et systèmes distribués",
        downloadResume: "Télécharger CV",
        contactMe: "Me Contacter"
      },
      about: {
        title: "À Propos",
        content: "Je suis un ingénieur en intelligence artificielle avec une expérience pratique dans la conception et le déploiement de systèmes intelligents  des solutions d'IA agentique comme les agents vocaux en temps réel et les chatbots automatisés, aux architectures RAG évolutives, aux déploiements LLM distribués et aux pipelines de machine learning qui résolvent des défis techniques concrets."
      },
      skills: {
        title: "Compétences",
        categories: {
          languages: "Langages & Frameworks",
          aiml: "Technologies IA/ML",
          infrastructure: "Infrastructure & DevOps",
          databases: "Bases de données & Traitement",
          tools: "Outils de développement"
        }
      },
      experience: {
        title: "Expérience Professionnelle",
        current: "Actuel",
        duration: "Durée"
      },
      projects: {
        title: "Projets",
        viewGithub: "Voir sur GitHub",
        techStack: "Technologies"
      },
      education: {
        title: "Formation",
        degree: "Diplôme",
        field: "Domaine d'étude"
      },
      volunteering: {
        title: "Bénévolat & Leadership"
      },
      honors: {
        title: "Honneurs & Récompenses"
      },
      contact: {
        title: "Contactez-moi",
        subtitle: "N'hésitez pas à me contacter pour des collaborations ou juste pour dire bonjour",
        email: "Email",
        phone: "Téléphone",
        linkedin: "LinkedIn",
        location: "Localisation",
        form: {
          name: "Votre nom",
          email: "Votre email",
          message: "Votre message",
          submit: "Envoyer le message",
          sending: "Envoi en cours..."
        },
        successMessage: "Merci ! Votre message a été envoyé avec succès.",
        errorMessage: "Désolé, une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer."
      },
      footer: {
        rights: "Tous droits réservés"
      }
    }
  },
  ar: {
    translation: {
      nav: {
        home: "الرئيسية",
        about: "نبذة عني",
        skills: "المهارات",
        experience: "الخبرة",
        projects: "المشاريع",
        education: "التعليم",
        volunteering: "العمل التطوعي",
        honors: "الجوائز",
        contact: "اتصل بي"
      },
      hero: {
        greeting: "مرحباً، أنا",
        name: "أسامة شعبان",
        title: "مهندس ذكاء اصطناعي ومهندس بيانات",
        subtitle: "خريج حديث في هندسة البيانات متخصص في الذكاء الاصطناعي والأنظمة الموزعة",
        downloadResume: "تحميل السيرة الذاتية",
        contactMe: "تواصل معي"
      },
      about: {
        title: "نبذة عني",
        content: "أنا مهندس ذكاء اصطناعي أمتلك خبرة عملية في بناء ونشر الأنظمة الذكية  من حلول الذكاء الاصطناعي الوكيلة مثل الوكلاء الصوتيين في الوقت الفعلي وروبوتات المحادثة الآلية، إلى بنيات RAG القابلة للتوسع، ونشر نماذج LLM الموزعة، وخطوط تعلم الآلة التي تحل تحديات تقنية واقعية."
      },
      skills: {
        title: "المهارات",
        categories: {
          languages: "اللغات والأطر",
          aiml: "تقنيات AI/ML",
          infrastructure: "البنية التحتية و DevOps",
          databases: "قواعد البيانات ومعالجة البيانات",
          tools: "أدوات التطوير"
        }
      },
      experience: {
        title: "الخبرة المهنية",
        current: "حالي",
        duration: "المدة"
      },
      projects: {
        title: "المشاريع",
        viewGithub: "عرض على GitHub",
        techStack: "التقنيات المستخدمة"
      },
      education: {
        title: "التعليم",
        degree: "الدرجة",
        field: "مجال الدراسة"
      },
      volunteering: {
        title: "العمل التطوعي والقيادة"
      },
      honors: {
        title: "الجوائز والتكريمات"
      },
      contact: {
        title: "تواصل معي",
        subtitle: "لا تتردد في التواصل معي للتعاون أو مجرد قول مرحباً",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        linkedin: "لينكد إن",
        location: "الموقع",
        form: {
          name: "اسمك",
          email: "بريدك الإلكتروني",
          message: "رسالتك",
          submit: "إرسال الرسالة",
          sending: "جاري الإرسال..."
        },
        successMessage: "شكراً لك! تم إرسال رسالتك بنجاح.",
        errorMessage: "عذراً، حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى."
      },
      footer: {
        rights: "جميع الحقوق محفوظة"
      }
    }
  }
};